<script>
import {computed, defineComponent, ref, watch} from "vue";
import ButtonFileUpload from "@/components/buttons/ButtonFileUpload.vue";
import MainCard from "@/components/cards/MainCard";
import InputText from "primevue/inputtext";
import Textarea from 'primevue/textarea';
import {useVuelidate} from "@vuelidate/core";
import {required} from "@/utils/i18n-validators";
import {useI18n} from "vue-i18n";
import {useStore} from "vuex";

export default defineComponent({
  components: {
    ButtonFileUpload,
    MainCard,
    Textarea,
    InputText,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    person: {
      type: Object,
      required: true,
    },
    addError: {
      type: Object,
      required: false,
    },
    chooseFiles: {
      type: Function,
      required: true,
    }
  },
  emits: ['deletePerson', 'updatePerson'],
  setup(props, {emit}) {
    const {t} = useI18n()
    const form = ref({...props.person})
    const store = useStore();
    const lang = computed(() => store.getters.getLang);
    const textField = computed(() => props.person.id && props.person.id.toString().includes('new') ? 'text_ru' : `text_${lang.value}`);
    const nameField = computed(() => props.person.id && props.person.id.toString().includes('new') ? 'name_ru' : `name_${lang.value}`);
    const formRules = computed(() => ({
       [nameField.value]: { required },
       photo: {
         required
       },
      [textField.value]: { required },
    }))
    const v$ = useVuelidate(formRules, form.value);
    watch(() => form.value,
        () => {
          emit('updatePerson', props.index, form.value)
        }, { deep: true }
    )
    return {
      form,
      v$,
      t,
      textField,
      nameField,
    };
  }
});
</script>

<template>
  <MainCard
  :title="t('founders.title', index + 1)"
  withDelete
  @deleteItem="$emit('deletePerson', index)"
  :index="index"
  class="mb-3"
>
<div class="mb-5 mt-2">
  <div class="w-full">
    <span class="p-float-label w-full">
      <InputText
          v-model="form[nameField]"
          :class="['w-full', {'p-invalid': v$[nameField]?.$errors?.length || (addError?.item.id === form.id && addError?.error[nameField]?.length) }]"
          id="person-name"
      />
      <label for="person-name">{{ t('founders.placeholder') }} <i style="color: #E26B6B">*</i></label>
    </span>
    <span v-if="v$[nameField]?.$errors?.length || (addError?.item.id === form.id && addError?.error[nameField]?.length)" class="text-xs color-error">
      {{ addError?.item.id === form.id && addError?.error[nameField]?.length ? addError.error[nameField][0] : t(v$[nameField]?.$errors?.[0].$message) }}
    </span>
  </div>
</div>
<div class="w-full">
  <span class="p-float-label w-full">
    <Textarea
        v-model="form[textField]"
        :class="['w-full', 'p-inputtext', {'p-invalid': v$[textField]?.$errors?.length || (addError?.item.id === form.id && addError?.error[textField]?.length) }]"
        rows="7"
        cols="30"
        :id="index.toString()"
    />
    <label :for="index">Фраза <i style="color: #E26B6B">*</i></label>
  </span>
  <span v-if="v$[textField]?.$errors?.length || (addError?.item.id === form.id && addError?.error[textField]?.length)" class="text-xs color-error">
      {{ addError?.item.id === form.id && addError?.error[textField]?.length ? addError.error[textField][0] : t(v$[textField]?.$errors?.[0].$message) }}
  </span>
</div>
<div class="flex flex-column mt-2 gap-2">
  <h1>Фотография основателя <i style="color: #E26B6B">*</i></h1>
  <span v-if="v$.photo?.$errors?.length || (addError?.item.id === form.id && addError?.error.photo?.length)" class="text-xs color-error">
      {{ addError?.item.id === form.id && addError?.error.photo?.length ? addError.error.photo[0] : t(v$.photo?.$errors?.[0].$message) }}
    </span>
  <div v-if="form.photo" >
    <img class="brand__persons-image" :src="person.photo.objectURL ? person.photo.objectURL : person.photo.preview_url" />
  </div>
  <div>
    <ButtonFileUpload
        @chooseFiles="chooseFiles"
        :label="form.photo ? 'Заменить фотографию' : 'Добавить фотографию'"
        :multiple="false"
        :index="index"
        :clear-files-after-select="true"
        :classes="{'brand__image': true}"
    />
  </div>
</div></MainCard>
</template>

<style lang="scss" scoped>
.brand {
  &__persons {
    &-image {
      width: 205px;
      height: 205px;
      border-radius: 100px;
    }
  }
}
</style>
